<div class="dialog-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="d-grid gap-14">
        <div class="form-group">
            <app-input context="Normal" class="form-item" label="Focus area name"
                placeholder="Enter your focus area name" type="text" [control]="form.get('focusAreaName')"
                formControlName="focusAreaName" [required]="true"
                [customErrorMessages]="customErrorMessages.focusAreaName">
            </app-input>
        </div>

        <div>
            <div class="note-text">Description
            </div>
            <div class="note-container">
                <div>
                    <textarea class="note-input" formControlName="description" (input)="autoResize($event)"
                        placeholder="Enter your description" [class.error]="hasDescriptionError()">
                    </textarea>
                </div>
            </div>
            <div *ngIf="hasDescriptionError()" class="error-message">
                {{ getDescriptionError() }}
            </div>
        </div>

        <button type="submit" style="display: none;" #submitBtn></button>
    </form>
</div>